import RarityMerkleTree from 'config/constants/nfts/merkle/rarity-merkle.json'
import { LockDuration, LockStatus } from '../types'

export const getStatus = (currentTime: number, lockStartTime: number, lockDuration: number): LockStatus => {
  // Add an extra check to currentBlock because it takes awhile to fetch so the initial value is 0
  // making the UI change to an inaccurate status
  if (lockStartTime === 0) {
    return 'locked'
  }

  if (currentTime < lockStartTime + lockDuration) {
    return 'locked'
  }

  return 'finished'
}

export const getLockApr = (aprRates, boostRates, duration, nfts): number => {
  if (!LockDuration[duration]) return 0
  let baseApr = aprRates[LockDuration[duration]]
  for (let i = 0; i < nfts.length; i++) {
    const rarity = RarityMerkleTree.claims?.[nfts[i]]?.rarity
    if (rarity >= 0) baseApr += boostRates[rarity]
  }
  return baseApr / 100
}

export const getRaritiesAndProofs = (nfts) => {
  const rarities = nfts.map((nft) => RarityMerkleTree.claims?.[nft]?.rarity)
  const proofs = nfts.map((nft) => RarityMerkleTree.claims?.[nft]?.proof)

  return { rarities, proofs }
}

export default null

